const Home = () => import(/* webpackChunkName: 'home' */ './home');
const Notice = () => import(/* webpackChunkName: 'home' */ './notice');
const Noticelist = () => import(/* webpackChunkName: 'home' */ './noticelist');
const UpdatePassword = () => import(/* webpackChunkName: 'home' */ './updatePassword');
const Iframe = () => import(/* webpackChunkName: 'home' */ './iframe');
const IframeView = () => import(/* webpackChunkName: 'home' */ './iframeView');

const routes = [
  { path: '/home', component: Home },
  { path: '/notice', component: Notice },
  { path: '/notice/list', component: Noticelist },
  { path: '/updatepassword', component: UpdatePassword },
  { path: '/skyline/*', component: Iframe },
  { path: '/skyline', component: IframeView },
];

export default routes;
